export default {
  pageFilters: [
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null
      }
    }
  ],
  queries: {
    topPerformingShows: { fields: ['country', 'daysInPast', 'contentType'] },
    homepageShowAnticipation: { fields: ['country', 'releaseDate'] },
    trendingActors: { fields: ['country', 'contentType'] },
    trendingShows: { fields: ['country'] },
    topPerformingShowsBinge: { fields: ['country', 'daysInPast'] }
    // homepageShowsHottestMoments: { fields: ['country', 'date'] }
  }
};
